export const getAvailableTimes = async () => {
  const availabilityApiUrl = process.env.REACT_APP_CALENDLY_AVAILABILITY_API_URL;

  // TODO: Real Calendly calls must go through a backend/serverless proxy.
  // Never put Calendly access tokens or other secrets in frontend code.
  if (!availabilityApiUrl) {
    return { ok: false, collection: [], error: "missing_availability_endpoint" };
  }

  const now = new Date();
  now.setMinutes(now.getMinutes() + 5);

  const endDate = new Date();
    endDate.setDate(endDate.getDate() + 7);

    const eventType = process.env.REACT_APP_CALENDLY_EVENT_TYPE;


  let url;

  try {
    url = new URL(availabilityApiUrl);
  } catch {
    return { ok: false, collection: [], error: "invalid_availability_endpoint" };
  }

  if (!["http:", "https:"].includes(url.protocol)) {
    return { ok: false, collection: [], error: "invalid_availability_endpoint" };
  }

    url.searchParams.set("event_type", eventType);
  url.searchParams.set("start_time", now.toISOString());
  url.searchParams.set("end_time", endDate.toISOString());

  try {
      const token = process.env.REACT_APP_CALENDLY_TOKEN;

      const response = await fetch(url.toString(), {
          method: "GET",
          headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
          },
      });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Availability request failed");
    }

    return { ok: true, collection: data.collection || [] };
  } catch (error) {
    console.error("Error loading availability:", error);
    return { ok: false, collection: [], error: "availability_request_failed" };
  }
};
